import type { FeatureFlagName } from '@terra/shared-contracts-feature-flags';
import { useFeatureFlagsContext } from '../app/providers/FeatureFlagsProvider';

export const useFeatureFlags = (featureFlag: FeatureFlagName) => {
  const { featureFlags, isLoading, isFetched } = useFeatureFlagsContext();

  const value = featureFlags[featureFlag];
  return {
    isFeatureFlagEnabled: typeof value === 'boolean' ? value : false,
    isLoading,
    isFetched,
  };
};
